import { useMutation, useQuery } from "@tanstack/react-query";
import adminService from "../services/admin";
import { FETCH_QUERY_KEYS } from "../consts";
import { CACHE_DURATION } from "@consts";

export const useFetchOpenDrafts = () => useQuery({
  queryKey: [FETCH_QUERY_KEYS.OPEN_DRAFTS],
  queryFn: adminService.fetchOpenDrafts,
  staleTime: CACHE_DURATION.ONE_MINUTE,
  select: (data) => data?.map((draft, index) => ({ ...draft, id: `draft-${index}` }))
});

export const useDuplicateAssistant = () => useMutation({
  mutationFn: adminService.duplicateAssistant
});

export const useExtendDraft = (options = {}) => useMutation({
  mutationFn: adminService.extendDraft,
  ...options
});

export const useChangeDraftOwner = (options = {}) => useMutation({
  mutationFn: adminService.changeDraftOwner,
  ...options
});

export const useFetchDraftOwners = ({ enabled, accountId }) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.DRAFT_OWNERS, accountId],
  queryFn: () => adminService.fetchDraftOwners(accountId),
  enabled
});

export const useFetchFailures = () => useQuery({
  queryKey: [FETCH_QUERY_KEYS.FAILURES],
  queryFn: adminService.fetchFailures,
  staleTime: CACHE_DURATION.ONE_MINUTE,
  select: (data) => data?.map((failure, index) => ({ ...failure, id: `failure-${index}` }))
});

export const useFetchUtteranceOrder = () => useQuery({
  queryKey: [FETCH_QUERY_KEYS.UTTERANCES_ORDER],
  queryFn: adminService.fetchUtteranceOrder,
  staleTime: CACHE_DURATION.ONE_MINUTE
});

export const useUpdateUtteranceOrder = () => useMutation({
  mutationFn: adminService.updateUtteranceOrder
});

export const useFetchDataMappingsTables = (options = {}) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.DATA_MAPPINGS_TABLES],
  queryFn: adminService.fetchDataMappingsTables,
  ...options
});

export const useFetchSpecRefs = (collectionName, channel) => useQuery({
  queryKey: ["specRefs", collectionName, channel],
  queryFn: () => adminService.fetchSpecRefs({ collectionName, channel }),
  enabled: !!collectionName && !!channel
});

export const useFetchTablesOptions = (collectionName, collectionInstanceId) => useQuery({
  queryKey: ["tablesOptions", collectionName, collectionInstanceId],
  queryFn: () => adminService.fetchTablesOptions({ collectionName, collectionInstanceId }),
  enabled: !!collectionName && !!collectionInstanceId
});

export const useFetchTableByTableId = (params) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.DATA_MAPPING_TABLE, params?.tableId, params?.collectionName, params?.collectionInstanceId],
  queryFn: () => adminService.fetchTableByTableId(params),
  enabled: !!params?.tableId && !!params?.collectionName && !!params?.collectionInstanceId,
  refetchOnWindowFocus: false
});

export const useUpdateTableFields = () => useMutation({
  mutationFn: adminService.updateTableFields
});

export const useCreateTable = () => useMutation({
  mutationFn: adminService.createTable
});

export const useUpdateUtteranceGrouping = () => useMutation({
  mutationFn: adminService.updateUtteranceGrouping
});

